import React from 'react';
import { IFormFieldInputBaseProps } from '@components/form-fields';
import { IEnhancedMenuItem } from '../table/types';
import EnhancedMenu from './EnhancedMenu';

interface IActionMenuProps extends IFormFieldInputBaseProps {
  actions: IEnhancedMenuItem[];
  title: string;
}

const ActionMenu: React.FC<IActionMenuProps> = ({ actions, title }) => {
  return <EnhancedMenu title={title} items={actions}></EnhancedMenu>;
};

export default ActionMenu;
